const Loading: React.FC = () => {
  return 'Loading';
};

export default Loading;
